import React, { useState } from "react";
import OverlayContact from "./OverlayContact";

const SingleContact = ({ id, img, name, title, university, links }) => {
  const [isOverlayTrue, setIsOverLayTrue] = useState(false);
  return (
    <article key={id} data-aos="zoom-out-up"
    className="inside-cocktail-section">
      <img src={img} alt={name} className="img-main-list" />
      <div className="text-inside-main-cocktail">
        <h2 className="h2">{name}</h2>
        <h4 className="h4">Title: {title}</h4>
        <h5 className="h5">university: {university}</h5>
        <a
          onClick={(e) => {
            e.preventDefault();
            setIsOverLayTrue(true);
          }}
          href=""
          className="a-link"
        >
          Follow us via
        </a>
      </div>
      {/* Overlay section */}
      <OverlayContact
        img={img}
        name={name}
        links={links}
        isOverlayTrue={isOverlayTrue}
        setIsOverLayTrue={setIsOverLayTrue}
      />
    </article>
  );
};

export default SingleContact;
